import {
  listEvents,
  listMarkets,
  type CatalogueEvent,
  type CatalogueMarket,
} from '../catalogue/catalogue-client';
import { getCuratedEvents, type CuratedEvent } from './catalogue-client';

export type { CatalogueEvent, CatalogueMarket, CuratedEvent };

/*
 * The contest editor's catalogue browse needs (CAE-298): list Events to add, an Event's Markets
 * to curate — both API-16, reused from apps/admin/src/catalogue/catalogue-client.ts (CAE-281) —
 * and resolving an already-curated Event's display name (reused from ./catalogue-client.ts,
 * built for the detail page's Slate tab event heads; the curation document carries only
 * pointers). `listMarkets` covers an already-curated Event too (fetched again on load), so the
 * editor has one browse path for both "what's curated" and "what else could be added".
 */
export interface EditorCatalogueClient {
  listEvents: typeof listEvents;
  listMarkets: typeof listMarkets;
  getCuratedEvents: typeof getCuratedEvents;
}

export const defaultEditorCatalogueClient: EditorCatalogueClient = {
  listEvents,
  listMarkets,
  getCuratedEvents,
};
